import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'

import { qrActions } from '../../store/actions'
import { coreFunctions } from '../../utils'

import { UseImage, GenericContainer,Buttons } from '../../components'
//import { mainStyles } from '../../styles/Main.js'
import { useStyles } from './QrCodeStyle'
import { Typography, useMediaQuery,useTheme
} from '@mui/material'
import dsimageImg from '../../assets/dsimage.jpg'
import endCaptureImg from '../../assets/endCapture.svg'

export default function TransitionDocComponent(props) {
    const matches = useMediaQuery('(max-width:600px)');
    const gridContainer = {} //mainStyles.gridStyle()
    const localStyles = useStyles()
    const [qrCode, setQrCode] = useState(null)
    const [uidCode, setUidCode] = useState('')
    const [transitionView, setTransitionView] = useState(false)
    const [notValid, setNotValid] = useState(false)

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const qrFile = useSelector(state => state.AssociatedFile)

    useEffect(() => {
        const params = props.location.search.replace('?', '').split('&');
        if (params != undefined && params != null && params[0] != "") {
            // console.log('token',params[1].split('=')[1])
            // console.log('code',params[0].split('=')[1])
            sessionStorage.setItem('token', params[1].split('=')[1])
            setUidCode(params[0].split('=')[1])
            setTransitionView(true)
        }else{
            setNotValid(true)
        }
    }, [])


    useEffect(() => {
        if (transitionView) {
            dispatch(qrActions.GetAssociatedFile({
                QRUID: uidCode
            }))
            setQrCode('ok')
        }
    }, [transitionView])


    useEffect(() => {
        if (qrFile.items != undefined && qrFile.items?.FileData != undefined && qrCode != null) {
            let stage = qrFile.items.FileData.Stage
            let stageId = stage.Id
            let stageName = stage.Name
            let folioId = qrFile.items.FileData.Id
            let qrProcess = true
            let nextComponent = coreFunctions.GetLegoNext(stageName)
            coreFunctions.DoNextStage({ navigate, nextComponent, State: { stageName, stageId, stage, folioId ,qrProcess} })
        }
        if (qrFile.error != undefined) {
            setNotValid(true)
        }
    }, [qrFile])


    return (
        <GenericContainer>
            {!notValid
                ? <div>
                    <div className={localStyles.loadingQrContent}>
                        <Typography variant="h6"><b>Sincronizando carga de documentos.</b></Typography>

                    </div>
                    {!matches &&
                        <div className={localStyles.footer}>
                            <UseImage src={dsimageImg} className={localStyles.footerlogo} />
                            <Typography variant="subtitle2" className={localStyles.footerText}><b>@2021 DocSolutions</b></Typography>
                        </div>}
                </div>

                : <div className={gridContainer.centerContent}>

                    <Typography variant="h6"><b>Captura finalizada</b></Typography>
                    <Typography variant="subtitle2">Haz concluido con el proceso de carga de documentos. Para continuar con tu solicitud debes regresar a la aplicación móvil.</Typography>
                    <div className={localStyles.imageSection}>
                        <UseImage src={endCaptureImg} className={localStyles.img}/>
                    </div>
                </div>}          
        </GenericContainer>
    )
}